export const StatusCountActionTypes = {
  FETCH_STATUS_COUNT_START: "FETCH_STATUS_COUNT_START",
  FETCH_STATUS_COUNT_SUCCESS: "FETCH_STATUS_COUNT_SUCCESS",
  FETCH_STATUS_COUNT_FAILURE: "FETCH_STATUS_COUNT_FAILURE",
  FETCH_STATUS_COUNT_CHANGED: "FETCH_STATUS_COUNT_CHANGED",
  STATUS_COUNT_RESET: "STATUS_COUNT_RESET",
  FETCH_AGENTS_START: "FETCH_AGENTS_START",
  FETCH_AGENTS_SUCCESS: "FETCH_AGENTS_SUCCESS",
  FETCH_AGENTS_FAILURE: "FETCH_AGENTS_FAILURE",
  FETCH_AGENTS_CHANGED: "FETCH_AGENTS_CHANGED",
  AGENTS_LIST_RESET: "AGENTS_LIST_RESET",
};

export interface IStatusCount {
  // Add your status count interface properties here
  id: string;
  count: number;
  status: string;
  // ... other properties
}
